export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyDaN3OXmruVrWrwxGVcVTPxAGw6mbP1bZo",
    authDomain: "woorifood-312f4.firebaseapp.com",
    projectId: "woorifood-312f4",
    storageBucket: "woorifood-312f4.appspot.com",
    messagingSenderId: "621221512150",
    appId: "1:621221512150:web:164d1c1b12080cff1c5a77",
    measurementId: "G-9JM8XNTMG9"
  },
};

